import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tds-report',
  templateUrl: './tds-report.component.html',
  styleUrls: ['./tds-report.component.scss']
})
export class TdsReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
